import { Settings } from '../types/settings';

export const PICK_UP = 'pick_up';
export const DROP_OFF_RETURN_METHOD = 'drop_off';
export const EPARCEL = 'eparcel';
export const HUBBED = 'hubbed';
export const MULTIPLE = 'multiple';
export const RETURN_IN_STORE = 'return_in_store';
export const SELF_RETURN = 'self_return';

export type ReturnMethod =
  | 'hubbed'
  | 'eparcel'
  | 'couriers_please'
  | 'tnt'
  | 'bonds'
  | 'sing_post'
  | 'teleport'
  | 'ninja_van_standard'
  | 'morning_express'
  | 'multiple'
  | 'pick_up'
  | 'drop_off'
  | 'return_in_store'
  | 'self_return';

export default function getReturnMethod(settings: Settings): ReturnMethod {
  if (settings.dropoff_providers || settings.pickup_providers) {
    const dropoffProviders = settings.dropoff_providers || [];
    const pickupProviders = settings.pickup_providers || [];
    if (dropoffProviders.length && !pickupProviders.length) {
      return DROP_OFF_RETURN_METHOD;
    }

    if (!dropoffProviders.length && pickupProviders.length) {
      return PICK_UP;
    }

    return MULTIPLE;
  }

  // INTL-1449: TODO remove this method when enable_new_fields_for_au fully rolled out
  const hasOnlyOneReturnMethod = !(
    (settings.hubbed_enabled && settings.eparcel_dropoff_enabled) ||
    (settings.eparcel_dropoff_enabled && settings.pickup_enabled) ||
    (settings.pickup_enabled && settings.hubbed_enabled)
  );
  if (hasOnlyOneReturnMethod) {
    if (settings.hubbed_enabled) return HUBBED;
    if (settings.eparcel_dropoff_enabled) return EPARCEL;
    if (settings.pickup_enabled) return PICK_UP;
  }
  return MULTIPLE;
}
